import { useEffect, useState } from "react"
import { getSubscriptionStatusBegin } from "../redux/actions/billingActions"
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationState } from "../interface/ApplicationState"
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';


import SubscriptionsIcon from '@mui/icons-material/Subscriptions'
import SettingsIcon from '@mui/icons-material/Settings'
import { Link } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import moment from 'moment'
import { alpha, useTheme } from "@mui/material/styles";
import { SubscriptionModal } from "./subscriptions/SubscriptionModal";


export const SubscriptionStatusBadge = () =>
{
  const theme = useTheme()
  const dispatch = useDispatch()
  const subscriptionStatus = useSelector((state: ApplicationState) => state.billing.subscriptionStatus);
  const isGettingSubscriptions = useSelector((state: ApplicationState) => state.billing.isGettingSubscriptions);
  const user = useSelector((state: ApplicationState) => state.userStore.user);

  const [ showSubscriptionsModal, setShowSubscriptions ] = useState(false)

  
  useEffect(() => {

    dispatch(getSubscriptionStatusBegin())

  }, [])


  return(<div>

    { subscriptionStatus?.mode === "trial" ? 
     <Button  onClick={() => setShowSubscriptions(true)} sx={styles.button(theme)} startIcon={<SubscriptionsIcon />}>Free Trial {subscriptionStatus.daysRemaining} days left</Button>
    : 

    <Tooltip title={subscriptionStatus?.mode === "paid" ? `Trading enabled and working - thanks for your payment!` : `Free mode (trial expired ${moment(user.createdAt).add(1, 'month').fromNow()})`}>
      { isGettingSubscriptions ? 

        <Button 
        onClick={() => setShowSubscriptions(true)}
        size="small"
        sx={styles.button(theme)} 
        startIcon={<CircularProgress size={16} />}>Checking subscription</Button> 
        
        : 

        <Button
          onClick={() => setShowSubscriptions(true)}
          sx={styles.button(theme)} 
          size="small"
          startIcon={subscriptionStatus?.isActive ? <SubscriptionsIcon /> : <SettingsIcon />}>
            Subscription {subscriptionStatus?.isActive ? "Active" : "(Free)"}
          </Button>} 

        </Tooltip> }

        { showSubscriptionsModal && <SubscriptionModal open handleClose={() => setShowSubscriptions(false)} user={user}/>}

  </div>)
}

const styles = {
  button: (theme: any) => ({
    color: theme.palette.mode === "dark" ? "#EEEEEE" : alpha(theme.palette.text.primary, 0.9),
    borderRadius: "999px",
    px: 1.25,
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.04 : 0.66),
    border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.38)}`,
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.07 : 0.84),
    },
  }),
}
